import PageHero from "@/components/feature/PageHero";
import Overview from "./Overview";
import NewsBoard from "./NewsBoard";
import { useMemo, useState } from "react";
import { news } from "@/mocks/news";
import type { NewsItem } from "@/types/content";

const allNews = news as NewsItem[];

export default function TopicsContent() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () => (active === "all" ? allNews : allNews.filter((item) => item.categorySlug === active)),
    [active],
  );

  const handleSelect = (slug: string) => {
    setActive(slug);
    window.setTimeout(() => {
      const el = document.getElementById("board");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  return (
    <>
      <PageHero
        crumbs={[{ label: "首页", to: "/" }, { label: "分类专题" }]}
        eyebrow="TOPICS"
        title="分类专题"
        desc="六个栏目各自对应不同的更新节奏。按栏目浏览，能更快找到你持续关注的那一类话题。"
      />
      <Overview active={active} onSelect={handleSelect} />
      <NewsBoard active={active} onSelect={setActive} list={list} />
    </>
  );
}